import distributeBalanceUnallocated from './distribute-balance-unallocated.json';
import distributeUnallocatedBalanceSuccess from './distribute-unallocated-balance-success.json';

export default {
  'unallocated-balance': {
    ...distributeBalanceUnallocated,
    ...distributeUnallocatedBalanceSuccess,
  },
};
